module.exports = __webpack_public_path__ + "static/lifetime-active-sellers-1faa9e0d0c95611e4a4e5d2252b091c2.png";